/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import Table from "./Table"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import TopBarIndividual from "./TopBar"
import { useEditOrgUserMutation, useExportOrganizationUsersMutation, useGetOrganizationUserQuery } from "../../slices/apiSlice"
import { handleSystemConfig } from "../../redux/systemConfigSlice"
import { dataService } from "../../services/data.services"
import OrganizationUserSearch from "./AdvancedSearch"
import { resetOrgUserSearch, setOrgUserSearchApplied } from "../../redux/orgUserSearchSlice"

export default function ManageOrganizationUser() {
    const { setToastmessage, setToastErrorMessage, isSideBar, isAdvancedSearchOpen } = useContext(GlobalContext);
    const [editUser] = useEditOrgUserMutation()
    const [exportOrganizationUsers] = useExportOrganizationUsersMutation()
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [skip, setSkip] = useState(true)
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading, setLoading] = useState(false)
    const [isSortselected, setisSortSelected] = useState(false)
    const selectedRows = useSelector(state => state.MultiSelectSlice.selectedRows.selectedIds)
    const [confirmationState, setConfirmationState] = useState({ isOpen: false, rowData: '', multirow: '', user_names: [] });
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [emptyField, setEmptyField] = useState(false);
    const [datePartialFilled,setDatePartialFilled] = useState(false);
    const { data, isFetching, isLoading, status } = useGetOrganizationUserQuery(searchParams?.toString(), { skip: skip || location.search === '' })
    const searchApplied = useSelector((state) => state.orgUserSearchData.org_user_searchApplied);
    const organizationUserSearch = useSelector(state => state.orgUserSearchData);
    
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */

    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }
    
    useEffect(() => {
        if (location.search === '') {
            setSkip(true)
        }
        if (location.state !== null && location.state !== '' && location?.state?.limit !== undefined && !Array.isArray(location.state)) {
            
            let params = {};
            if (location?.state?.search !== '' && location?.state?.search !== null) {
                
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'sort': 'created_at+desc',
                    'search': decodeURIComponent(location.state.search),
                    'search_mode': location.state.search_mode
                }
            } else {
                
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'sort': 'created_at+desc',
                }

            }
            setSearchParams({ ...params })
        }
        else {

            if (!searchParams.get('limit')) {
                handleSearchParams('limit', '15')
            }
            if (!searchParams.get('page_number')) {
                handleSearchParams('page_number', '1')
            }
            if (!searchParams.get('sort')) {
                handleSearchParams('sort', `created_at+desc`)
            }
        }

        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')

    }, [location]);

    useEffect(() => {
        if (searchParams.size >= 3) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])

    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })

    }

    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }
    }, [data?.organizationUsers]);

    const handleChange = (val) => {
        handleSearchParams('search', val)

    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleCheckboxChange = (event, type) => {
        const { id, checked } = event.target;
        setFilterValues((prevState) => {
            const newState = { ...prevState };
            newState[type] = checked
                ? [...(newState[type] || []), id]
                : (newState[type] || []).filter((item) => item !== id);
            return newState;
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);




    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async (e) => {

        if ((confirmationState?.rowData !== undefined && confirmationState?.rowData !== "" && confirmationState?.rowData?.status === 'active' && textAreaMsg.trim() === '') || (confirmationState?.multirow === "deactive" && (textAreaMsg.trim() === ''))) {
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        try {
            let body = {}
            if (confirmationState?.rowData !== undefined && confirmationState?.rowData !== "") {
                {
                    confirmationState?.rowData?.status === 'inactive' ?
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": ''
                        } :
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": textAreaMsg
                        }
                }
            }
            else {
                confirmationState?.multirow === "deactive" ?
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": textAreaMsg
                    }
                    :
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": ''

                    }
            }
            setLoading(true)
            const activationRes = await editUser({ body })
            setLoading(false)

            if (activationRes?.error) {
                setToastErrorMessage('Something went wrong. Please try again')
            } else {
                if (confirmationState?.multirow !== "" && confirmationState?.multirow !== undefined) {
                    setToastmessage(`Organization users ${confirmationState?.multirow === "active" ? "activated" : "deactivated"} successfully`);
                }
                else {
                    setToastmessage(`Organization user ${confirmationState?.rowData?.status === "inactive" ? "activated" : "deactivated"} successfully`);
                }
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})

        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    useEffect(()=>{
        return(()=>{
            dispatch(resetArrays())
        })
    },[])
    
    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();
    
        const searchParams = new URLSearchParams(window.location.search); // Use URLSearchParams
    
        const buildSearchString = (field, value, inverse, domain) => {
            if (!value && !domain) return ""; // Early exit if both are empty
            const prefix = inverse ? 'ne:' : '';
            const formattedValue = value === '-' ? '__NULL__' : (value?.trim() || ''); // Simplified NULL handling
            const formattedDomain = domain === '-' ? '__NULL__' : (domain?.trim() || '');
            if (domain) {
                return `${field}=${prefix}${encodeURIComponent(formattedValue)}@${encodeURIComponent(formattedDomain)};`;
            }
            return `${field}=${prefix}${encodeURIComponent(formattedValue)};`;
        };
    
        const buildPhoneSearchString = (field, code, number, inverse) => {
            if (!code && !number) return ""; // Early exit if both are empty
            const prefix = inverse ? 'ne:' : '';
            const formattedCode = code === '-' ? '__NULL__' : (code || '');
            const formattedNumber = number === '-' ? '__NULL__' : (number || '');
            return `${field}=${prefix}${formattedCode ? '+' : ''}${encodeURIComponent(formattedCode)}-${encodeURIComponent(formattedNumber)};`;
        };
    
        let searchString = "";
    
        searchString += buildSearchString("user_id", organizationUserSearch?.user_id, organizationUserSearch?.user_id_inverse);
        searchString += buildSearchString("user_name", organizationUserSearch?.user_name, organizationUserSearch?.user_name_inverse, organizationUserSearch.user_name_domain);
        searchString += buildSearchString("first_name", organizationUserSearch?.first_name, organizationUserSearch?.first_name_inverse);
        searchString += buildSearchString("last_name", organizationUserSearch?.last_name, organizationUserSearch?.last_name_inverse);
        searchString += buildSearchString("email_address", organizationUserSearch?.email_address, organizationUserSearch?.email_address_inverse, organizationUserSearch.email_address_domain);
        searchString += buildPhoneSearchString("mobile_country_code-mobile_number", organizationUserSearch?.mobile_number_code, organizationUserSearch.mobile_number, organizationUserSearch.mobile_number_inverse);
        searchString += buildPhoneSearchString("main_country_code-main_number", organizationUserSearch?.main_number_code, organizationUserSearch.main_number, organizationUserSearch.main_number_inverse);
    
    
        if (Array.isArray(organizationUserSearch.status)) {
            const prefix = organizationUserSearch.status_inverse ? 'ne:' : '';
            searchString += organizationUserSearch.status.map(status => `status=${prefix}${encodeURIComponent(status)};`).join('');
        }
    
        if (Array.isArray(organizationUserSearch.permission)) {
            const prefix = organizationUserSearch.permission_inverse ? 'ne:' : '';
            searchString += organizationUserSearch.permission.map(permission => `permission_access=${prefix}${encodeURIComponent(permission)};`).join('');
        }
    
        const { created_day, created_month, created_year } = organizationUserSearch || {};
        const isPartialDateFilled = (created_day && (!created_month || !created_year)) || (created_month && (!created_day || !created_year)) || (created_year && (!created_day || !created_month));
    
        if (isPartialDateFilled) {
            setDatePartialFilled(true);
            return;
        } else if (created_day && created_month && created_year) {
            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;
            const epochDate = Math.floor(new Date(`${dateStr}T00:00:00`).getTime() / 1000);
            const prefix = organizationUserSearch.created_date_inverse ? 'ne:' : '';
            searchString += `created_at=${prefix}${epochDate};`;
        }
    
        searchString = searchString.slice(0, -1); // Remove trailing ';' (more efficient than endsWith)
    
        const newParams = {
            ...Object.fromEntries(searchParams),
            search: searchString || '',
            search_mode: organizationUserSearch.match === false ? 'and' : 'or',
            sort: searchParams.get('sort') || 'created_at+desc', // Use URLSearchParams.get
            page_number: 1,
            limit: searchParams.get('limit') || '15', // Use URLSearchParams.get
        };
    
        if (!newParams.search) delete newParams.search;
    
        window.history.pushState(null, "", `?${new URLSearchParams(newParams)}`); // Update URL directly
        setSearchParams(newParams); // This triggers the re-render
        dispatch(setOrgUserSearchApplied());
    };
    
    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetOrgUserSearch());
        }
    }, [dispatch, searchApplied]);

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Organization Users"} />
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarIndividual
                            title={'List of Organization Users'}
                            path={'/manage-admin-corporate/add-admin-corporate'}
                            AddButton={true}
                            SearchInput={((data?.organizationUsers?.length === 0 && searchParams.get("search") === null) || data === undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Organization User"}
                            menuBar={(data !== undefined && selectedRows?.length > 0) ? true : false}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-organization-users/addOrganizationUser'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID', 'Username', 'First Name', 'Last Name', 'Permission', 'Status', 'Email Address', 'Main Number', 'Mobile Number', 'Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportUsers={exportOrganizationUsers}
                            handleCheckboxChange={handleCheckboxChange}
                            isIdexport={true}
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))? <CustomOverLay Active text="Loading Organization User list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay' : 'overlay-list'}`} /> : (data !== undefined && data?.organizationUsers?.length > 0) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data?.organizationUsers}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}


                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />

                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {/* {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false") || (searchParams.get("status")!==null||searchParams.get("permission_access")!==null) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count === 0 && !searchParams.get("search") ? <Emptyscreen
                                title={"Manage Organization Users"}
                                FirstPTag={"No Organization users added yet."}
                                SecondePTag={"Start managing by clicking 'Add Organization User'"}
                            /> : (data?.total_count === 0 && data?.organizationUsers?.length === 0) && <SearchEmptyScreen text={"No data found"} />
                        } */}

                        {
                            // Case 1: No exact matches found during a search
                            (data?.total_count === 0 && suggestions?.trim() !== "") || 
                                data?.success_status === false || 
                                searchParams.get("search") !== null || 
                                searchParams.get("status") !== null || 
                                searchParams.get("permission_access") !== null ? (
                                    <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                                ) : 
                            // Case 2: No organization users (default view with no active search)
                                data?.total_count === 0 &&
                                    !searchParams.get("search") && 
                                    !searchParams.get("status") && 
                                    !searchParams.get("permission_access") ? (
                                        <Emptyscreen
                                            title={"Manage Organization Users"}
                                            FirstPTag={"No Organization users added yet."}
                                            SecondePTag={"Start managing by clicking 'Add user'"}
                                            organizationUser={true}
                                        />
                                    ) : 
                                // Case 3: Fallback for rejected requests or unexpected empty data
                                    (status === "rejected" || 
                                        (data?.total_count !== 0 && data?.organizationUsers?.length === 0)) ? (
                                            <SearchEmptyScreen text={"No data found"} />
                                        ) : null
                        }


                    </>}
                </div>
                {confirmationState.isOpen &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle={confirmationState?.rowData !== "" ? confirmationState?.rowData?.status === "inactive" ? 'Activate' : 'Deactivate' : confirmationState.multirow === "active" ? 'Activate' : 'Deactivate'}
                                message={confirmationState.rowData !== "" ? `Are you sure you want ${confirmationState?.rowData?.status === "inactive" ? 'activate' : 'deactivate'} this organization user?` :
                                    `Are you sure you want to ${confirmationState.multirow === 'active' ? 'activate' : 'deactivate'} the following organization users?`}
                                textMessage={confirmationState.rowData !== "" ? confirmationState?.rowData?.status === 'inactive' ? true : false : confirmationState.multirow === "active" ? true : false}
                                buttonName={confirmationState.rowData !== "" ? confirmationState?.rowData?.status === "inactive" ? 'Activate' : 'Deactivate' : confirmationState.multirow === 'active' ? 'Activate' : 'Deactivate'}
                                userList={confirmationState?.multirow === '' ? '' : confirmationState?.multirow === "deactive" ? (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name) : (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name)}
                                loadingActivation={loading}
                                disabled={loading}
                            />
                        }
                    />
                }
                {isAdvancedSearchOpen&&searchParams?.get('limit') &&
                <OrganizationUserSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                />
                }
            </div>
        </>

    )
}